var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStatsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_876:2632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8895 2.54469C11.0565 2.37765 11.3408 2.49624 11.3408 2.73212V10.6768C11.3408 10.8234 11.2222 10.9407 11.0769 10.9407H3.1322C2.89632 10.9407 2.77903 10.6564 2.94478 10.4894L10.8895 2.54469Z",
    fill: "#E41F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.531137 9.63008C0.585977 9.42607 0.840981 9.3585 0.990147 9.50766L1.37776 9.89527L11.1228 0.150256C11.323 -0.0499227 11.6494 -0.0499227 11.8495 0.150256C11.9503 0.250984 12 0.382298 12 0.513639C12 0.644967 11.9503 0.776294 11.8495 0.877021L2.10453 10.622L2.49214 11.0097C2.64131 11.1588 2.57245 11.4138 2.36971 11.4687L0.431672 11.9876C0.176667 12.0564 -0.0566492 11.8231 0.0122147 11.5681L0.531137 9.63008Z",
    fill: "#E41F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_876:2632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 1 12 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatsDown);
export default __webpack_public_path__ + "static/media/icon-stats-down.500ab617.svg";
export { ForwardRef as ReactComponent };